import { render, staticRenderFns } from "./pv.vue?vue&type=template&id=de6581ac&scoped=true&"
var script = {}
import style0 from "./pv.vue?vue&type=style&index=0&id=de6581ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6581ac",
  null
  
)

export default component.exports